import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import { Icon, Switch } from "@mui/material";
import PropTypes from "prop-types";
import SoftButton from "components/SoftButton";
import SoftAvatar from "components/SoftAvatar";

function Title({ title, subTitle, image }) {
    return (
        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
            <SoftBox mr={2}>
                <SoftAvatar src={image} alt={title} size="sm" variant="rounded" />
            </SoftBox>
            <SoftBox display="flex" flexDirection="column">
                <SoftTypography variant="button" fontWeight="medium">
                    {title}
                </SoftTypography>
                <SoftTypography variant="caption" color="secondary">
                    {subTitle}
                </SoftTypography>
            </SoftBox>
        </SoftBox>
    );
}
Title.defaultProps = {
    title: "",
    image: "",
    subTitle: "",
};
Title.propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
};

function Slug({ job }) {
    return (
        <SoftBox display="flex" flexDirection="column">
            <SoftTypography variant="caption" fontWeight="medium" color="text">
                {job}
            </SoftTypography>
        </SoftBox>
    );
}
Slug.defaultProps = {
    job: "",
};
Slug.propTypes = {
    job: PropTypes.string.isRequired,
};

function Actions({ currentJobData, handleEditItem, handleDeleteItem }) {
    return <>
        <SoftButton variant="gradient" color="info" iconOnly={true} onClick={() => handleEditItem(currentJobData)}>
            <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={() => handleEditItem(currentJobData)}>
                create
            </Icon>
        </SoftButton>
        &nbsp;
        <SoftButton variant="gradient" color="error" iconOnly={true} onClick={() => handleDeleteItem(currentJobData)}>
            <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={() => handleDeleteItem(currentJobData)}>
                delete
            </Icon>
        </SoftButton>
    </>;
}
Actions.defaultProps = {
    currentJobData: {},
    handleEditItem: () => { },
    handleDeleteItem: () => { },
};
Actions.propTypes = {
    currentJobData: PropTypes.object.isRequired,
    handleEditItem: PropTypes.func.isRequired,
    handleDeleteItem: PropTypes.func.isRequired,
};
function jobJobListing(categoryData, handleEditItem, handleDeleteItem, addEditJob) {
    return {
        columns: [
            {
                colummKey: "title",
                name: "Title",
                align: "left",
                width: '300px'
            },
            {
                colummKey: "slug",
                name: "Slug",
                align: "left",
                width: '150px'
            },
            {
                colummKey: "publish_date",
                name: "Publish Date",
                align: "center",
                width: '75px'
            },
            {
                colummKey: "seoStatus",
                name: "Seo Status",
                align: "center",
                width: '100px'
            },
            {
                colummKey: "status",
                name: "Status",
                align: "center",
                width: '25px'
            },
            {
                colummKey: "action",
                name: "Action",
                align: "center",
                width: '100px'
            },
        ],

        rows: categoryData ? categoryData.map((singleJob) => {
            return {
                title: <Title
                    title={singleJob.title}
                    image={singleJob.image}
                    subTitle={
                        singleJob.category_name !== '' && singleJob.category_name !== null ?
                            'Category : ' + singleJob.category_name :
                            ''
                    } />,
                slug: <Slug
                    job={singleJob.slug} />,
                seoStatus: (
                    <SoftBadge
                        variant="gradient"
                        badgeContent={
                            singleJob.seo_status === 1 ?
                                'Active' :
                                'Deactive'
                        }
                        color={
                            singleJob.seo_status === 1 ?
                                'success' :
                                'secondary'
                        }
                        size="md"
                        container />
                ),
                publish_date: (
                    <SoftBadge
                        variant="gradient"
                        badgeContent={singleJob.publish_date}
                        color="dark"
                        size="md"
                        container />
                ),
                status: (
                    <Switch
                        color="success"
                        size="md"
                        defaultChecked={singleJob.status === 1 ? true : false}
                        onChange={(event) => {
                            singleJob['status'] = event.target.checked ? 1 : 0;
                            addEditJob(singleJob);
                        }} />
                ),
                action: (
                    <Actions
                        currentJobData={singleJob}
                        handleEditItem={handleEditItem}
                        handleDeleteItem={handleDeleteItem} />
                )
            };
        }) : [],
    };
};

export default jobJobListing;
